export default __webpack_public_path__ + "static/media/black-felt.19061ce4.webp";